import { render, staticRenderFns } from "./InfiniteHits.vue?vue&type=template&id=4c05a18c&scoped=true&"
import script from "./InfiniteHits.vue?vue&type=script&lang=js&"
export * from "./InfiniteHits.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteHits.vue?vue&type=style&index=0&id=4c05a18c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05a18c",
  null
  
)

export default component.exports